export const translations = {
  en: {
    // Navbar & Footer
    home: "Home",
    partners: "Partners",
    articles: "Articles",
    myDashboard: "My Dashboard",
    logout: "Log Out",
    login: "Log In",
    signup: "Sign Up",
    exploreShares: "Browse Shares",
    search: "Search",

    // Common Buttons & Labels
    confirm: "Confirm",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    submit: "Submit",
    upload: "Upload",
    loading: "Loading...",
    noResult: "No results found.",
    address: "Address",
    quantity: "Quantity",
    dateAndTime: "Date & Time",
    place: "Location",
    comment: "Comment",
    comments: "Comments",
    details: "Details",
    status: "Status",
    foodName: "Food Name",
    foodPhoto: "Food Image",
    share: "Share",


    // Landing Page
    bannerTitle: "Share",
    bannerSubtitle: "Share surplus food to help others and the environment through our exchange platform. Let's turn 'surplus food' into 'saved food' together!",
    startUsing: "Get Started",
    learnMore: "Learn More",
    foodTitle: "Food",
    foodDesc: "Over 820 million people worldwide suffer from hunger, meaning 1 in 9 people cannot access sufficient food.",
    saveTitle: "Save",
    saveDesc: "Taiwan produces about 3.4 million tons of food waste annually, equivalent to one box of fried rice per person daily.",
    valueTitle: "Value",
    valueDesc: "Food waste carbon emissions would rank third globally if it were a country. Saving food reduces carbon footprint for a better environment.",
    expertTag: "Expert",
    guruTag: "Guru",
    annaDesc: "You can dedicate a day as 'surplus food elimination day', use websites or apps, freeze unused ingredients, and prepare smaller portions. The best way is to finish your meal.",
    johnDesc: "When dining out, pack leftovers or ask servers not to serve items you won't eat. You can also support restaurants that donate surplus food or adopt low-carbon processes.",
    othersShares: "Other's Food Shares",

    // Login & Signup Pages
    welcomeBack: "Welcome back",
    createAccount: "Create Account",
    username: "Username",
    email: "Email",
    password: "Password",
    haveAccount: "Already have an account?",
    noAccount: "Don't have an account yet?",
    facebookLogin: "Log in with FB",
    googleLogin: "Log in with Google",

    // Validation & Error Alerts
    errEnterPassword: "Please enter your password.",
    errAccountNotExist: "The account you entered does not exist. Please sign up first.",
    errPasswordIncorrect: "Incorrect password. Please try again.",
    errInvalidEmail: "Invalid email format.",
    errEnterFoodName: "Please enter a food name.",
    errEnterQtyNumber: "Please enter a valid quantity (1 ~ 999).",
    errSelectDateTimeRange: "Please select a date and time range.",
    errSelectLocation: "Please click on the map marker to obtain the address.",
    errUploadFoodImage: "Please upload a food image.",
    errCommentEmpty: "Comment cannot be empty.",
    errSelectDateTime: "Please select the date and time for pickup.",
    errTimeTooEarly: "Pickup time cannot be earlier than the available start time.",
    errTimeTooLate: "Pickup time cannot be later than the available end time.",
    errTimeInPast: "Pickup time cannot be in the past.",
    errQtyFormat: "Quantity must be a number.",
    errQtyRange: "Quantity must be between 1 and the available amount.",
    errNameFormat: "First/Last Name format is incorrect.",
    errPasswordMismatch: "Passwords do not match.",
    errEnterAlias: "Please enter an alias.",
    errEnterLocation: "Please enter a location.",
    errPasswordLength: "Password must be at least 6 characters.",
    errEmailAlreadyInUse: "This email is already registered. Please log in instead.",
    registerSuccess: "Successfully registered",


    // Personal Dashboard & Pages
    mySharesList: "My Shared Items",
    myBadges: "My Badges",
    myReceivedRecord: "Received Records",
    myToReceiveList: "To Be Received",
    myCollectedShares: "Saved Shares",
    myCollectedPartners: "Saved Partners",
    myMessages: "My Messages",
    newShare: "Add a Share",
    editShare: "Edit Share",
    shareDetail: "Share Details",
    exchangeInfo: "Exchange Info",
    confirmPickup: "Confirm Pickup",
    exchangePlace: "Exchange Location",
    scanQRCodeDesc: "Scan QR Code for exchange information",
    recipient: "Recipient",
    phone: "Phone",
    emailLabel: "Email",
    notProvided: "Not provided",
    confirmPickupSuccess: "You have confirmed the surplus food pickup.",
    cancelSuccess: "You have confirmed the cancellation.",
    noReservation: "No reservations found.",
    noShareList: "You have no shared items or reservations.",
    noCollectedShares: "You have no saved shares.",
    noCollectedPartners: "You have no saved partners.",
    noMessages: "You have no messages.",
    noReceivedRecord: "You have no received records.",
    noToReceiveList: "You have no items to receive.",
    noSharedItems: "You have no shared items.",

    // Search Page
    searchPlaceholder: "Search food shares...",
    enterKeyword: "Please enter a keyword",
    foodCategory: "Category",
    all: "All",
    shareType: "Share Type",
    restaurant: "Restaurant",
    individual: "Individual",
    searchBtn: "Search",
    searchBannerTitle: "Surplus Food",
    searchBannerSubtitle: "Generous people are often blessed. Sharing with others makes life more colorful and interesting.",
    currentSharesTitle: "Currently Shared Surplus Food",

    happyToShare: "Joy of Sharing",
    restaurantSubtitle: "Sharing doubles the joy. Sharing is a belief in life, and sharing is another form of happiness.",
    searchPartners: "Search partners...",
    clearSearch: "Clear Search",
    menuShares: "Shares",
    menuStats: "Stats",
    menuRecord: "Records",
    menuToReceive: "Booked",
    menuCollected: "Saved",
    menuStore: "Partners",



    // Article Page
    readMore: "Read More",
    author: "Author",
    publishDate: "Published Date",
    backToHome: "Back to Home",
    pageNotFound: "Page Not Found",
    articlesTitle: "Surplus Food & Solutions",
    articlesSubtitle: "Fight food waste by sharing surplus food. Share your extra resources; surplus food can light up the streets. Let's find innovative solutions to tackle food waste together.",
    searchArticles: "Search articles...",
    noArticlesFound: "No articles found.",
    manageReservations: "Manage Bookings",
    notSetYet: "Not Set",
    searchFood: "Search Shares",
    shareFoodPlusTen: "Share Food +10",
    qtyRangeMinMax: "Please enter a quantity between 1 and {max}.",
    currentQuantity: "Current Qty",
    requestedQuantity: "Request Qty",
    enterQuantity: "Enter quantity",
    availableTimeRange: "Available Time",
    tagSaved: "#Saved",
    btnBook: "Book",
    catSaved: "Saved",
    tagReceived: "#Received",
    errEndTimeTooEarly: "End time cannot be earlier than start time. Please re-select.",
    errStartTimeInPast: "Start time cannot be in the past. Please re-select.",
    originalDateTime: "Original Date & Time",
    changeDateTime: "Change Date & Time",
    confirmUpdate: "Confirm Update",
    btnEdit: "Edit",
    catShare: "Share",
    tagToReceive: "#To Receive",
    catReceive: "Receive",
    postComment: "Comment",
    commentCountLabel: "{count} comments",
    pickupQuantity: "Pickup Qty",
    titleMyShareList: "My Share List",
    titleMyChartBadges: "My Stats & Badges",
    titleMyReceivedList: "My Received List",
    titleMyToReceiveList: "My Bookings",
    titleMyCollectedList: "My Saved Shares",
    titleMyCollectedRestaurants: "My Saved Partners",
    titleMemberUpdate: "Update Profile",
    titleMyMgmtPage: "Manage Bookings",
    titleNotification: "My Messages",
    noBadge: "You have no badges yet.",
    memberCategory: "Member",
    confirmDeleteTitle: "Are you sure you want to delete this {category}?",
    errEnterName: "Please enter your name.",
    errEnterPhone: "Please enter a 10-digit phone number.",
    errDescribeSelf: "Please describe yourself.",
    errUploadPhoto: "Please upload a photo.",
    enterPhone: "Enter phone number",
    enterLocation: "Enter location",
    describeYourself: "Describe yourself",
    update: "Update",
    deleteMember: "Delete Account",
    errNotOwnerOrRecipient: "You are not the owner or recipient of this share.",
    confirmCancelSuccess: "You have confirmed the cancellation of this share.",
    confirmReceiveSuccess: "You have confirmed the pickup of this share.",
    titleQRcodeConfirm: "Share Booking Management",
    giver: "Provider",
    bookingCancelled: "This booking has been cancelled.",
    bookingCompleted: "This booking has been completed.",
    searchResults: "Search Results",
    noRestaurantFound: "No restaurants found.",
    searchAddressPlaceholder: "Search address...",
    errSelectLocationAlert: "Please select an address from the search results or drag the marker to get the address (Only Taiwan address search is supported).",
    errPleaseLogin: "Please log in first.",
    errCannotBookOwnShare: "Cannot book your own share, you can edit it under My Shares List.",
    errAlreadyReceived: "You have already received this item.",
    errAlreadyBooked: "You have already booked this item.",
    statusReceived: "Received",
    statusBooked: "Booked",
    btnView: "View",
    noCommentsYet: "No comments yet.",
    selectDateAndTime: "Select Date & Time",
    btnUpdateBooking: "Update Booking",
    pickupDateTime: "Pickup Date & Time",
  },


  zh: {
    // Navbar & Footer
    home: "首頁",
    partners: "合作餐廳",
    articles: "文章",
    myDashboard: "我的看板",
    logout: "登出",
    login: "登入",
    signup: "註冊",
    exploreShares: "他人分享",
    search: "搜尋",

    // Common Buttons & Labels
    confirm: "確認",
    cancel: "取消",
    edit: "編輯",
    delete: "刪除",
    submit: "確定",
    upload: "上傳",
    loading: "載入中...",
    noResult: "沒有任何結果。",
    address: "地址",
    quantity: "數量",
    dateAndTime: "日期及時間",
    place: "地點",
    comment: "評論",
    comments: "評論",
    details: "詳細資料",
    status: "狀態",
    foodName: "食物名稱",
    foodPhoto: "食物照片",
    share: "分享",


    // Landing Page
    bannerTitle: "分享",
    bannerSubtitle: "透過交換平台分享剩食幫助別人與環境，一起把「剩食」變成「勝食」吧！",
    startUsing: "開始使用",
    learnMore: "了解更多",
    foodTitle: "糧食",
    foodDesc: "全球有 8 億 2 千萬人仍處於飢餓狀態，相當於每 9 個人即有一人無法取得足夠糧食。",
    saveTitle: "節約",
    saveDesc: "台灣一年約有 340 萬噸的廚餘量，相當於每人每天的剩食量約一盒炒飯。",
    valueTitle: "價值",
    valueDesc: "如果全世界食物浪費的排碳量位居世界第三，透過惜食減碳，共創美好環境。",
    expertTag: "勝食專家",
    guruTag: "勝食達人",
    annaDesc: "可以挑選一天當作「剩食消滅日」、使用 APP 或是勝食網站、冷凍未使用之食材、製備小份餐點（現今一份餐點明顯大於 50 年前的份量），當然最好的方法還是「完食」。",
    johnDesc: "在餐廳用餐，建議打包未食用完之食物，或在一開始就請服務生不提供不想食用的食物，另外也可多去有捐剩食、或低碳製程考量的餐廳，以表支持。",
    othersShares: "他人勝食分享",

    // Login & Signup Pages
    welcomeBack: "歡迎回來",
    createAccount: "建立新帳號",
    username: "使用者名稱",
    email: "電子郵件",
    password: "密碼",
    haveAccount: "已經有帳號了？",
    noAccount: "還沒有建立帳號嗎？",
    facebookLogin: "使用 FB 登入",
    googleLogin: "使用 Google 登入",

    // Validation & Error Alerts
    errEnterPassword: "請輸入密碼。",
    errAccountNotExist: "您輸入的帳號不存在，請先註冊。",
    errPasswordIncorrect: "您輸入的密碼錯誤，請重新輸入密碼。",
    errInvalidEmail: "您的 email 資料格式錯誤。",
    errEnterFoodName: "請輸入食物名稱。",
    errEnterQtyNumber: "數量請輸入數字 1 ~ 999 的數字。",
    errSelectDateTimeRange: "請點選日期時間區間。",
    errSelectLocation: "請點選地點標示取得地址。",
    errUploadFoodImage: "請上傳食物圖片。",
    errCommentEmpty: "留言不能是空白。",
    errSelectDateTime: "請點選領取的日期時間。",
    errTimeTooEarly: "領取時間小於可領取的開始時間，請重新選擇領取時間。",
    errTimeTooLate: "領取時間大於可領取的結束時間，請重新選擇領取時間。",
    errTimeInPast: "領取時間小於現在時間，請重新選擇領取時間。",
    errQtyFormat: "數量請輸入數字。",
    errQtyRange: "請輸入介於 1 ~ 可領取數量的數字。",
    errNameFormat: "您的名字資料格式不符。",
    errPasswordMismatch: "密碼不相符。",
    errEnterAlias: "請輸入暱稱。",
    errEnterLocation: "請輸入地點。",
    errPasswordLength: "密碼長度需要至少六個字元。",
    errEmailAlreadyInUse: "此信箱已經註冊過，請您使用信箱或是 FB 及 Google 登入。",
    registerSuccess: "註冊成功",


    // Personal Dashboard & Pages
    mySharesList: "我的清單",
    myBadges: "我的勳章",
    myReceivedRecord: "領取紀錄",
    myToReceiveList: "尚未領取",
    myCollectedShares: "收藏清單",
    myCollectedPartners: "收藏店家",
    myMessages: "我的訊息",
    newShare: "發布分享",
    editShare: "編輯分享",
    shareDetail: "分享詳情",
    exchangeInfo: "交換資訊",
    confirmPickup: "確認領取",
    exchangePlace: "交換地點",
    scanQRCodeDesc: "請掃描 QR code 以取得交換資訊",
    recipient: "領取者",
    phone: "電話",
    emailLabel: "電子郵件",
    notProvided: "未提供",
    confirmPickupSuccess: "您已確認對方領取完勝食。",
    cancelSuccess: "您已確認對方取消勝食。",
    noReservation: "目前沒有任何預約。",
    noShareList: "目前您沒有任何的分享清單，也沒有任何預約。",
    noCollectedShares: "你沒有任何的收藏清單。",
    noCollectedPartners: "你沒有任何的收藏店家。",
    noMessages: "你目前沒有任何的訊息。",
    noReceivedRecord: "你沒有任何的領取紀錄。",
    noToReceiveList: "你沒有任何的尚未領取清單。",
    noSharedItems: "目前沒有任何分享清單。",

    // Search Page
    searchPlaceholder: "搜尋勝食分享...",
    enterKeyword: "請輸入關鍵字",
    foodCategory: "食物類別",
    all: "全部",
    shareType: "分享類型",
    restaurant: "餐廳",
    individual: "個人",
    searchBtn: "搜尋",
    searchBannerTitle: "勝食",
    searchBannerSubtitle: "善於分享的人時常受到眷顧，常與他人分享讓生活更多采多姿更有趣",
    currentSharesTitle: "目前其他人分享的勝食",

    happyToShare: "樂於分享",
    restaurantSubtitle: "分享快樂加倍，分享是一種生活的信念，分享是另一種幸福",
    searchPartners: "餐廳搜尋",
    clearSearch: "清除搜尋",
    menuShares: "清單",
    menuStats: "統計",
    menuRecord: "紀錄",
    menuToReceive: "已訂",
    menuCollected: "收藏",
    menuStore: "店家",



    // Article Page
    readMore: "閱讀更多",
    author: "作者",
    publishDate: "發佈日期",
    backToHome: "返回首頁",
    pageNotFound: "找不到此頁面",
    articlesTitle: "剩食與解決",
    articlesSubtitle: "透過分享剩食打擊食物浪費，分享你多出的資源，剩食也可以點亮街燈，讓我們共謀解決剩食的創新之道",
    searchArticles: "文章搜尋",
    noArticlesFound: "搜尋不到文章",
    manageReservations: "管理預訂",
    notSetYet: "尚未設定",
    searchFood: "勝食搜尋",
    shareFoodPlusTen: "分享勝食 +10",
    qtyRangeMinMax: "請輸入介於 1 ~ {max} 的數字",
    currentQuantity: "目前數量",
    requestedQuantity: "登記數量",
    enterQuantity: "請輸入數量",
    availableTimeRange: "可領取時段",
    tagSaved: "#收藏",
    btnBook: "領取",
    catSaved: "收藏",
    tagReceived: "#已領",
    errEndTimeTooEarly: "結束時間小於開始時間，請重新選擇結束時間",
    errStartTimeInPast: "開始時間小於現在時間，請重新選擇開始時間",
    originalDateTime: "原定時間及日期",
    changeDateTime: "更改日期及時間",
    confirmUpdate: "確認更新",
    btnEdit: "編輯",
    catShare: "分享",
    tagToReceive: "#未領",
    catReceive: "領取",
    postComment: "留言",
    commentCountLabel: "目前共 {count} 則留言",
    pickupQuantity: "領取數量",
    titleMyShareList: "我的分享清單",
    titleMyChartBadges: "我的統計與勳章",
    titleMyReceivedList: "我已領取的清單",
    titleMyToReceiveList: "我的尚未領取清單",
    titleMyCollectedList: "我的收藏清單",
    titleMyCollectedRestaurants: "我的收藏店家",
    titleMemberUpdate: "個人資料更新",
    titleMyMgmtPage: "領取列表管理",
    titleNotification: "我的訊息",
    noBadge: "目前沒有任何的勳章",
    memberCategory: "會員",
    confirmDeleteTitle: "確認刪除此{category}",
    errEnterName: "請輸入姓名",
    errEnterPhone: "請輸入10個數字的電話號碼",
    errDescribeSelf: "請描述關於你",
    errUploadPhoto: "請上傳照片",
    enterPhone: "請輸入電話",
    enterLocation: "請輸入地點",
    describeYourself: "請描述你自己",
    update: "更新",
    deleteMember: "刪除會員",
    errNotOwnerOrRecipient: "您非此剩食的擁有者或是領用者",
    confirmCancelSuccess: "您已確認對方取消勝食",
    confirmReceiveSuccess: "您已確認對方領取完勝食",
    titleQRcodeConfirm: "勝食領取管理",
    giver: "提供者",
    bookingCancelled: "該領取已經取消",
    bookingCompleted: "該領取已經完成",
    searchResults: "搜尋結果",
    noRestaurantFound: "搜尋不到餐廳",
    searchAddressPlaceholder: "地址搜尋",
    errSelectLocationAlert: "請選擇有搜尋出的地址或使用拖拉 Marker 來取得地址(本站僅提供台灣的地址搜尋)",
    errPleaseLogin: "請先登入",
    errCannotBookOwnShare: "無法領取自己的勝食，可以到 \"清單\" 編輯",
    errAlreadyReceived: "您已經領取過了",
    errAlreadyBooked: "您已經預定領取了",
    statusReceived: "已領取",
    statusBooked: "已預訂",
    btnView: "查看",
    noCommentsYet: "目前沒有任何的留言",
    selectDateAndTime: "選擇日期及時間",
    btnUpdateBooking: "我要更新",
    pickupDateTime: "領取日期及時間",
  }
};


